import { isBrowser, SHIPT_USER_ID_KEY, } from "@shipt/analytics-core";
import { getContext, getAnonymousId, postWorkerMessage, setValue, } from "./utils/browser";
/**
 *
 * @param traits https://segment.com/docs/connections/spec/identify/#traits
 */
export const identify = (traits, options) => {
    try {
        if (!isBrowser()) {
            return;
        }
        if (traits === null || traits === void 0 ? void 0 : traits.id) {
            setValue(SHIPT_USER_ID_KEY, String(traits.id));
        }
        const payload = {
            // @ts-ignore because Segment is infuriatingly inconsistent wanting traits at top-level for identify calls
            traits,
            context: getContext({ ...options === null || options === void 0 ? void 0 : options.context, traits }),
            anonymousId: getAnonymousId(),
            type: "identify",
        };
        postWorkerMessage({ options: payload });
    }
    catch (e) {
        console.error(e);
    }
};
